import http from '../http/http';

import {
    HHSRS_CLEAR_RESCORE_WARNING,
    generateEndpoint,
    HHSRS_NATIONAL_AVERAGES_FOR_HAZARD,
    HHSRS_SCORING_BY_INSPECTION,
    HHSRS_VALIDATION_STATUS,
} from '../http/endpoints';

export default (() => {
    const getOneByInspection = (inspectionId) =>
        http.get(
            generateEndpoint(HHSRS_SCORING_BY_INSPECTION, {
                inspectionId,
            })
        );

    const getValidationStatus = (inspectionId) =>
        http.get(
            generateEndpoint(HHSRS_VALIDATION_STATUS, {
                inspectionId,
            })
        );

    const getNationalAveragesForHazard = (inspectionId, hazardId) =>
        http.get(
            generateEndpoint(HHSRS_NATIONAL_AVERAGES_FOR_HAZARD, {
                inspectionId,
                hazardId,
            })
        );

    const update = (inspectionId, params) =>
        http.put(
            generateEndpoint(HHSRS_SCORING_BY_INSPECTION, {
                inspectionId,
            }),
            params
        );

    const remove = (inspectionId) =>
        http.delete(
            generateEndpoint(HHSRS_SCORING_BY_INSPECTION, {
                inspectionId,
            })
        );

    const clearRescoreWarning = (hazardId, inspectionId) =>
        http.put(
            generateEndpoint(HHSRS_CLEAR_RESCORE_WARNING, {
                hazardId,
                inspectionId,
            })
        );

    return {
        getOneByInspection,
        getValidationStatus,
        getNationalAveragesForHazard,
        update,
        remove,
        clearRescoreWarning,
    };
})();
